/**
 * Venue configuration for the geogated coaching overlay (Task 8).
 *
 * Placeholder coordinates point at LA City Hall — swap when Sutu confirms the
 * actual install location. The radius is intentionally generous so a phone
 * sitting indoors with weak GPS still resolves to "on-site" rather than
 * falling through to the off-site copy.
 *
 * `atVenue` is a UX hint only: it changes the copy + reference image shown on
 * the placement overlay. SLAM tap-to-place still works everywhere — see
 * CLAUDE.md decision #7 ("There is always a way to play").
 */
export const VENUE = {
  /** Decimal degrees, WGS-84. */
  lat: 34.0537,
  lng: -118.2428,
  /** Inclusion radius in metres. Generous on purpose — see file header. */
  radiusMeters: 120,
} as const;
